import styled from 'styled-components';
import { colors } from '../../colors';

export interface FrameProps {
  children: JSX.Element;
  borderRadius?: number;
  hasError?: boolean;
}
interface IFrameProps {
  border: number;
  hasError?: boolean;
}
export const Frame = styled.div<IFrameProps>`
  width: 100% !important;
  height: 100% !important;
  border: 1px solid ${(props) => (props.hasError ? colors.red30 : colors.black)};
  box-shadow: 4px 4px 0px
    ${(props) => (props.hasError ? colors.red30 : colors.black)};
  border-radius: ${(props) => props.border}px;
`;

export default Frame;
